import type {OrderReportSummary} from '../../types';

import {numberFormat} from 'utils/Helper';

type OrdersSummaryProps = {
  data?: OrderReportSummary;
};

const OrdersSummary: React.FC<OrdersSummaryProps> = ({data}) => {
  return (
    <div className="mx-4 my-2 flex flex-col gap-1 rounded-xl bg-gray-02 p-3">
      <span className="text-body-sm text-gray-07">مجموع فروش</span>
      <div className="flex items-center justify-between">
        <div className='flex flex-nowrap gap-2 items-center'>
          <h4 className="text-heading-h4 text-gray-09">
            {numberFormat(data?.sum_of_orders ?? 0)}
          </h4>
          <span className="text-body-sm text-gray-09"> تومان</span>
        </div>
        <span className="text-body-sm text-gray-07">{data?.count_of_orders ?? 0} سفارش</span>
      </div>
    </div>
  );
};

export default OrdersSummary;
